import * as React from "react";

import { getOrCreateGlobalContext, CONTEXT_KEYS } from "../utils";

interface NavigationContextProps {
	isNavigation: true;
}

interface NavigationProviderProps {
	children: JSX.Element;
}

const NavigationContext =
	getOrCreateGlobalContext<NavigationContextProps | null>(
		CONTEXT_KEYS.NAVIGATION,
		null,
	);

function NavigationProvider(props: NavigationProviderProps) {
	return (
		<NavigationContext.Provider value={{ isNavigation: true }}>
			{props.children}
		</NavigationContext.Provider>
	);
}

export { NavigationContext, NavigationProvider, type NavigationContextProps };
